"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.InstantResult = void 0;
var _mui = require("@ori-ui/mui");
var _testidGenerator = _interopRequireDefault(require("@ori/testid-generator"));
var _react = require("react");
var _hooks = require("../../hooks");
var _models = require("../../models");
var _Skeleton = require("../Skeleton");
var _shared = require("../shared");
var _FindPickupPointsSearchMessage = require("./FindPickupPointsSearchMessage");
var _InstantResultContent = require("./InstantResultContent");
var _jsxRuntime = require("react/jsx-runtime");
function _getRequireWildcardCache(e) {
  if ("function" != typeof WeakMap) return null;
  var r = new WeakMap(),
    t = new WeakMap();
  return (_getRequireWildcardCache = function (e) {
    return e ? t : r;
  })(e);
}
function _interopRequireWildcard(e, r) {
  if (!r && e && e.__esModule) return e;
  if (null === e || "object" != typeof e && "function" != typeof e) return {
    default: e
  };
  var t = _getRequireWildcardCache(r);
  if (t && t.has(e)) return t.get(e);
  var n = {
      __proto__: null
    },
    a = Object.defineProperty && Object.getOwnPropertyDescriptor;
  for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) {
    var i = a ? Object.getOwnPropertyDescriptor(e, u) : null;
    i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u];
  }
  return n.default = e, t && t.set(e, n), n;
}
const NearestPickupPoints = /*#__PURE__*/(0, _react.lazy)(async () => Promise.resolve().then(() => _interopRequireWildcard(require('./NearestPickupPoints'))));
const Root = (0, _mui.styled)('div')(({
  theme
}) => ({
  ..._shared.scrollingContainerStyles,
  display: 'flex',
  flexDirection: 'column',
  padding: theme.spacing(0, 3),
  [theme.breakpoints.up('sm')]: {
    padding: theme.spacing(0, 6)
  }
}));
const InstantResult = ({
  instantResults,
  instantResultChannelId,
  isInstantResultsLoading,
  isInstantResultOpened,
  isMapAvailable,
  isMapLayoutShown,
  onPickupPointItemConfirmation,
  pickupPointsListType,
  searchTerm,
  selectInstantResult
}) => {
  const {
    getTestIdProps
  } = (0, _testidGenerator.default)();
  const {
    display,
    formattedSearchConfiguration
  } = (0, _hooks.usePickupPointsSearchConfiguration)();
  const isSearchTermPresent = Boolean(searchTerm);
  const isNearestPickupPointsVisible = pickupPointsListType === _models.PickupPointsListType.NearestOptions && !isInstantResultOpened;
  const nearPickupPointsProps = {
    instantSearchTerm: searchTerm,
    isMapAvailable,
    onPickupPointItemConfirmation
  };
  const instantResultContentProps = {
    display,
    instantResults,
    isInstantResultsLoading,
    searchTerm,
    selectInstantResult
  };
  return /*#__PURE__*/(0, _jsxRuntime.jsxs)(_jsxRuntime.Fragment, {
    children: [isInstantResultOpened ? /*#__PURE__*/(0, _jsxRuntime.jsx)(Root, {
      ...getTestIdProps(_models.TestId.InstantResultContainer),
      children: isSearchTermPresent ? /*#__PURE__*/(0, _jsxRuntime.jsx)(_InstantResultContent.InstantResultContent, {
        ...instantResultContentProps
      }) : /*#__PURE__*/(0, _jsxRuntime.jsx)(_FindPickupPointsSearchMessage.FindPickupPointsSearchMessage, {
        formattedSearchConfiguration: formattedSearchConfiguration,
        isMapLayoutShown: isMapLayoutShown
      })
    }) : null, !isMapLayoutShown && isNearestPickupPointsVisible && Boolean(instantResultChannelId) ? /*#__PURE__*/(0, _jsxRuntime.jsx)(_react.Suspense, {
      fallback: /*#__PURE__*/(0, _jsxRuntime.jsx)(_Skeleton.NearestPickupPointsSkeleton, {}),
      children: /*#__PURE__*/(0, _jsxRuntime.jsx)(NearestPickupPoints, {
        instantResultChannelId: Number(instantResultChannelId),
        ...nearPickupPointsProps
      })
    }) : null]
  });
};
exports.InstantResult = InstantResult;
var _default = exports.default = InstantResult;